module.exports = __webpack_public_path__ + "static/img/2 2014中小企业创新项目.08ba92ba.jpg";